/*
  集字创作
*/

export default {
  state: {
    fontColor: '',
    backgroundColor: '',
    verticalMode: false,
    rightMode: false,
    groupsPosition: {},
    signatruesPosition: {}
  },
  mutations: {
    SET_FONT_COLOR (state, color) {
      state.fontColor = color
    },
    SET_BACKGROUND_COLOR (state, color) {
      state.backgroundColor = color
    },
    SET_VERTICAL_MODE (state, bool) {
      state.verticalMode = bool
    },
    SET_RIGHT_MODE (state, bool) {
      state.rightMode = bool
    },
    SET_GROUPS_POSITION (state, { index, data }) {
      state.groupsPosition[index] = data
    },
    SET_SIGNATRUES_POSITION (state, { index, data }) {
      state.signatruesPosition[index] = data
    }
  },
  actions: {
    setFontColor ({ commit }, color) {
      commit('SET_FONT_COLOR', color)
    },
    setBackgroundColor ({ commit }, color) {
      commit('SET_BACKGROUND_COLOR', color)
    },
    setVerticalMode ({ commit }, bool) {
      commit('SET_VERTICAL_MODE', bool)
    },
    setRightMode ({ commit }, bool) {
      commit('SET_RIGHT_MODE', bool)
    },
    setGroupsPosition ({ commit }, { index, data }) {
      commit('SET_GROUPS_POSITION', { index, data })
    },
    setSignatruesPosition ({ commit }, { index, data }) {
      commit('SET_SIGNATRUES_POSITION', { index, data })
    }
  }
}
